import { render } from "./VacancyLinkCard.vue?vue&type=template&id=0c1e0bb4&scoped=true"
import script from "./VacancyLinkCard.vue?vue&type=script&lang=js"
export * from "./VacancyLinkCard.vue?vue&type=script&lang=js"

import "./VacancyLinkCard.vue?vue&type=style&index=0&id=0c1e0bb4&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1e0bb4"]])

export default __exports__